module.exports = __webpack_public_path__ + "static/img/felipe.061f02f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/felipe.svg
// module id = H+X9
// module chunks = 0